import Pusher from 'pusher-js';
import Echo from 'laravel-echo';
import DocReady from '../integrations/unified/docReady.js';

window.Echo = new Echo({
  broadcaster: 'pusher',
  key: '65b59e6581d4170204b6',
  cluster: 'mt1',
});

DocReady.create(window, document)
  .listen(() => {
    let timeOutPusher = null;
    let mouseLastMove = 0;

    function inactivityCheck () {
      timeOutPusher = window.setTimeout(() => {
        window.Echo.leave();
      }, 5 * 60 * 1000);
    }
    document.onmousemove = () => {
      if (Date.now() - mouseLastMove > 5000) {
        if (timeOutPusher !== null) {
          window.clearTimeout(timeOutPusher);
        }

        inactivityCheck();

        mouseLastMove = Date.now();
      }
    };
  });
